import script from "./MediaSetEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaSetEditor.vue?vue&type=script&setup=true&lang=js"

import "./MediaSetEditor.vue?vue&type=style&index=0&id=118f3b77&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-118f3b77"]])

export default __exports__